'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getUi, hideModal } from '@/store/reducers/ui-slice';
import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';

export function FileDetailsModalContent(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  const content = modal?.content as {
    path: string;
  };

  const dispatch = useDispatch();

  const handleClose = (): void => {
    dispatch(hideModal());
  };

  if (!content?.path) return <></>;

  return (
    <Stack spacing={3}>
      <Box
        alt="File"
        component="img"
        src={`${process.env.NEXT_PUBLIC_CMS_V2_IMAGES_URL}${content?.path}`}
        sx={{ height: '100%', width: '100%', objectFit: 'contain' }}
      />

      <Stack direction="row" spacing={3} sx={{ mt: 3, justifyContent: 'initial' }}>
        <Button type="button" color="secondary" onClick={handleClose} sx={{ flex: '1 1 auto' }}>
          Close
        </Button>
      </Stack>
    </Stack>
  );
}
